import { IRequesterInfo } from '../../../../base/models'
import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IOrderReturn } from '../models/models'

export class PostOrderReturnApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'orderReturn/insert',
      requesterInfo,
    })
  }

  public async postOrderReturn(request: IOrderReturn): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
